import { PriceInfo } from '~/common/models';

export const getVehiclePrice = (
  variantId: string,
  postcode: string,
  additionalOptionsPrice?: string
): Promise<PriceInfo> =>
  fetch(
    `/api/pricing/${postcode}/${variantId}?totalOptions=${additionalOptionsPrice}`
  )
    .then((res) => res.json())
    .then((res) => res as PriceInfo);
